export const typeOptions = [
  { value: 1, label: 'Cleaning' },
  { value: 2, label: 'Coloc Buddy' },
  { value: 3, label: 'Purchases' },
  { value: 4, label: 'Other' },
];

export const periodOptions = [
  { value: 'this_month', label: 'This month' },
  { value: 'next_month', label: 'Next month' },
  { value: 'recurring', label: 'Recurring' },
];
